import { API_CONFIG, fetchAPI } from './api';

export interface LoginResponse {
  success: boolean;
  credits?: number;
  contactCredits?: number;
  contactCreditsResetAt?: string;
  isAdmin?: boolean;
  userType?: 'user' | 'admin' | 'free-trial';
  timezone?: string;
  features?: {
    customKpi?: boolean;
    contentScraping?: boolean;
    profitPod?: boolean;
    businessIntel?: boolean;
    pepaiResearch?: boolean;
    emailWorkspace?: boolean;
  };
  token?: string;
  error?: string;
}

export async function login(email: string, password: string, honeypot?: string): Promise<LoginResponse> {
  return fetchAPI<LoginResponse>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify({
      action: 'login',
      email,
      password,
      website: honeypot,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }),
  });
}

export async function signupFreeTrial(input: {
  email: string;
  password: string;
  trialSurveyOptIn: boolean;
  trialNewsletterOptIn: boolean;
  honeypot?: string;
}) {
  return fetchAPI<LoginResponse>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify({
      action: 'signup',
      email: input.email,
      password: input.password,
      website: input.honeypot,
      trialSurveyOptIn: input.trialSurveyOptIn,
      trialNewsletterOptIn: input.trialNewsletterOptIn,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }),
  });
}

export async function addCreditsAsAdmin(input: {
  requesterEmail: string;
  requesterPassword: string;
  targetEmail: string;
  amount: number;
}) {
  return fetchAPI<{ success: boolean; email?: string; credits?: number; error?: string }>(API_CONFIG.USERS_API, {
    method: 'POST',
    body: JSON.stringify({
      action: 'add_credits',
      ...input,
    }),
  });
}
